<template>
  <div class="edrea_tm_section" id="portfolio">
    <div class="section_inner">
      <div class="edrea_tm_portfolio swiper-section">
        <div class="edrea_tm_main_title">
          <h3>Services <span class="coloring">Portfolio</span></h3>
        </div>
        <div class="portfolio_list gallery_zoom">
          <swiper
            :loop="false"
            :slidesPerView="1"
            :spaceBetween="0"
            :loopAdditionalSlides="1"
            :autoplay="{
              delay: 6000,
            }"
            :navigation="{
              nextEl: '.my_next',
              prevEl: '.my_prev',
            }"
            :pagination="pagination"
            :breakpoints="{
              700: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              1200: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
            }"
            @slideChange="onSlideChange"
            :modules="modules"
            class="swiper-container"
          >
            <swiper-slide class="swiper-slide">
              <div class="list_inner">
                <div class="image">
                  <img src="img/portfolio/games.gif" alt="" />
                  <div class="main" data-img-url="img/portfolio/games.gif"></div>
                </div>
                <div class="details">
                  <h3>Mobile Games</h3>
                  <span>Detail</span>
                </div>
                <a class="edrea_tm_full_link portfolio_popup" href="#"></a>

                <!-- Portfolio Popup Informations -->
                <div class="edrea_tm_hidden_content">
                  <div class="portfolio_popup_details">
                    <div class="top_image">
                      <img src="img/thumbs/4-2.jpg" alt="" />
                      <div
                        class="main"
                        data-img-url="img/portfolio/player.jpg"
                        style="background-image: url('img/portfolio/player.jpg')"
                      ></div>
                    </div>
                    <div class="details">
                      <h3>Mobile Games</h3>
                    </div>
                    <div class="text">
                      <p>
                        We create mobile games that blend captivating design, 
                        intuitive gameplay, and scalable technology. From casual 
                        fun to strategy-driven experiences, our goal is to 
                        deliver apps that entertain and keep players engaged, 
                        while opening new opportunities for monetization.
                      </p>
                      <p>
                        Our team focuses on every stage of the development process: 
                        from concept and design to coding, testing, and publishing.
                        We integrate engaging storylines, smooth animations, and 
                        performance-optimized code to ensure an experience that 
                        feels professional and polished.Our team focuses on every 
                        stage of the development process: from concept and design 
                        to coding, testing, and publishing. We integrate engaging storylines, 
                        smooth animations, and performance-optimized code to ensure an 
                        experience that feels professional and polished.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- /Portfolio Popup Informations -->
              </div>
            </swiper-slide>

            <swiper-slide class="swiper-slide">
              <div class="list_inner">
                <div class="image">
                  <img src="img/portfolio/seo.gif" alt="" />
                  <div class="main" data-img-url="img/portfolio/seo.gif"></div>
                </div>
                <div class="details">
                  <h3>SEO & AEO</h3>
                  <span>Detail</span>
                </div>
                <a class="edrea_tm_full_link portfolio_popup" href="#"></a>

                <!-- Portfolio Popup Informations -->
                <div class="edrea_tm_hidden_content">
                  <div class="portfolio_popup_details">
                    <div class="top_image">
                      <img src="img/thumbs/seo.jpg" alt="" />
                      <div
                        class="main"
                        data-img-url="img/portfolio/seo.jpg"
                        style="background-image: url('img/portfolio/seo.jpg')"
                      ></div>
                    </div>
                    <div class="details">
                      <h3>SEO & AEO</h3>
                    </div>
                    <div class="text">
                      <p>
                        We specialize in Search Engine Optimization (SEO) and Answer Engine Optimization (AEO) 
                        to make your business easier to discover in an increasingly competitive digital world. 
                        Our approach goes beyond keywords—we optimize site structure, performance, and content 
                        strategy to ensure long-term visibility across search platforms.
                      </p>
                      <p>
                        With AEO, we prepare your content for the future of search, making it accessible to AI assistants, 
                        voice queries, and smart devices. This means your business can show up not only on Google, 
                        but also when customers ask Siri, Alexa, or ChatGPT-like systems for recommendations.
                      </p>
                      <p>
                        By combining advanced analytics, technical SEO, and high-quality content, 
                        we help you increase rankings, drive organic traffic, and capture more qualified leads. 
                        Our goal is simple: boost your visibility, authority, and growth by ensuring your brand 
                        is always the right answer.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- /Portfolio Popup Informations -->
              </div>
            </swiper-slide>
            
            <swiper-slide class="swiper-slide">
              <div class="list_inner">
                <div class="image">
                  <img src="img/portfolio/content.gif" alt="" />
                  <div class="main" data-img-url="img/portfolio/content.gif"></div>
                </div>
                <div class="details">
                  <h3>Content Monetization</h3>
                  <span>Detail</span>
                </div>
                <a class="edrea_tm_full_link portfolio_popup" href="#"></a>

                <!-- Portfolio Popup Informations -->
                <div class="edrea_tm_hidden_content">
                  <div class="portfolio_popup_details">
                    <div class="top_image">
                      <img src="img/portfolio/content.jpg" alt="" />
                      <div
                        class="main"
                        data-img-url="img/portfolio/content.jpg"
                        style="background-image: url('img/portfolio/content.jpg')"
                      ></div>
                    </div>
                    <div class="details">
                      <h3>Content Monetization</h3>
                    </div>
                    <div class="text">
                      <p>
                        We design and build websites focused on turning traffic into revenue 
                        through smart content strategies. Whether it's display advertising, 
                        affiliate marketing, or branded partnerships, our goal is to create 
                        platforms that generate consistent income while delivering real 
                        value to visitors.
                      </p>
                      <p>
                        Our process starts with research-driven content planning: identifying 
                        profitable niches, high-volume keywords, and engaging topics that 
                        attract the right audience. From there, we combine SEO best practices 
                        with user-friendly layouts and fast-loading pages that keep readers 
                        engaged and coming back.
                      </p>
                      <p>
                        By aligning monetization models with high-quality publishing, we ensure 
                        that every piece of content serves both the audience and the business. 
                        The result: sustainable growth, scalable revenue streams, and websites 
                        that work for you 24/7—even while you sleep.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- /Portfolio Popup Informations -->
              </div>
            </swiper-slide>

            <swiper-slide class="swiper-slide">
              <div class="list_inner">
                <div class="image">
                  <img src="img/portfolio/ecommerce.gif" alt="" />
                  <div class="main" data-img-url="img/portfolio/ecommerce.gif"></div>
                </div>
                <div class="details">
                  <h3>Web Apps & eCommerce</h3>
                  <span>Detail</span>
                </div>
                <a class="edrea_tm_full_link portfolio_popup" href="#"></a>

                <!-- Portfolio Popup Informations -->
                <div class="edrea_tm_hidden_content">
                  <div class="portfolio_popup_details">
                    <div class="top_image">
                      <img src="img/portfolio/ecommerce.jpg" alt="" />
                      <div
                        class="main"
                        data-img-url="img/portfolio/ecommerce.jpg"
                        style="background-image: url('img/portfolio/ecommerce.jpg')"
                      ></div>
                    </div>
                    <div class="details">
                      <h3>Web Apps & eCommerce</h3>
                    </div>
                    <div class="text">
                      <p>
                        We develop modern web applications and eCommerce platforms that transform 
                        ideas into powerful digital experiences. Our focus is on building fast, 
                        secure, and scalable solutions that help businesses grow while delivering 
                        seamless experiences to their customers.
                      </p>
                      <p>
                        From intuitive front-end design to robust back-end systems, we handle the 
                        full development cycle. We integrate secure payment gateways, product 
                        management, and analytics dashboards, ensuring every platform is ready for 
                        real-world use and long-term scalability.
                      </p>
                      <p>
                        Whether you need a custom web app to optimize business operations or a fully 
                        featured online store, we create solutions that are user-friendly, mobile-ready, 
                        and conversion-focused. Our goal is to help brands expand their reach, 
                        improve customer engagement, and maximize online revenue.
                      </p>
                    </div>
                  </div>
                </div>
                <!-- /Portfolio Popup Informations -->
              </div>
            </swiper-slide>
            
            <div class="edrea_tm_swiper_progress fill">
              <div class="my_pagination_in">
                <span class="current">0</span>
                <span class="pagination_progress"
                  ><span class="all"
                    ><span
                      style="
                        transform: translate3d(0px, 0px, 0px) scaleX(0.75)
                          scaleY(1);
                      "
                    ></span></span
                ></span>
                <span class="total">04</span>
              </div>
              <div class="my_navigation">
                <ul>
                  <li>
                    <a class="my_prev" href="#"
                      ><i class="icon-left-open-1"></i
                    ></a>
                  </li>
                  <li>
                    <a class="my_next" href="#"
                      ><i class="icon-right-open-1"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </swiper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import Swiper core and required modules

// Import Swiper Vue.js components
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import { swiperSliderCustomSlider } from "../utilits";

export default {
  name: `PortfolioComponent`,
  components: {
    Swiper,
    SwiperSlide,
  },
  methods: {
    onSlideChange(swiper) {
      this.activeSlider = swiper.activeIndex + 1;
    },
  },
  setup() {
    return {
      modules: [Navigation, Pagination],
      pagination: {
        el: ".edrea_tm_swiper_progress",
        type: "custom", // progressbar
        renderCustom: function (swiper, current, total) {
          swiperSliderCustomSlider(current, total);
        },
      },
    };
  },
};
</script>
